(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lyfe-news-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const button = document.querySelector('[data-article-copy]');
    if (!button) return;
    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(button.dataset.copyUrl);
        button.textContent = button.dataset.copiedLabel;
        window.setTimeout(() => { button.textContent = button.dataset.copyLabel; }, 1600);
      } catch {
        const field = document.createElement('textarea');
        field.value = button.dataset.copyUrl;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.append(field);
        field.select();
        document.execCommand('copy');
        field.remove();
        button.textContent = button.dataset.copiedLabel;
        window.setTimeout(() => { button.textContent = button.dataset.copyLabel; }, 1600);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyfe-news-feed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-news-feed]');
    if (!root) return;
    const list = root.querySelector('[data-news-list]');
    const sort = root.querySelector('[data-news-sort]');
    root.addEventListener('click', async event => {
      const sortButton = event.target.closest('[data-news-sort-option]');
      if (sortButton) {
        const posts = [...list.querySelectorAll('[data-news-post]')];
        const direction = sortButton.dataset.newsSortOption === 'oldest' ? 1 : -1;
        posts.sort((a, b) => direction * (Number(a.dataset.published) - Number(b.dataset.published)));
        posts.forEach(post => list.append(post));
        root.querySelectorAll('[data-news-sort-option]').forEach(button => {
          const selected = button === sortButton;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        sort.open = false;
        return;
      }
      const toggle = event.target.closest('[data-news-toggle]');
      if (toggle) {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const content = document.getElementById(toggle.getAttribute('aria-controls'));
        toggle.setAttribute('aria-expanded', String(!expanded));
        toggle.textContent = expanded ? toggle.dataset.showMore : toggle.dataset.showLess;
        content.hidden = expanded;
        return;
      }
      const copy = event.target.closest('[data-copy-link]');
      if (copy) {
        try {
          await navigator.clipboard.writeText(copy.dataset.copyUrl);
          copy.textContent = copy.dataset.copiedLabel;
          window.setTimeout(() => { copy.textContent = copy.dataset.copyLabel; }, 1600);
        } catch {
          const field = document.createElement('textarea');
          field.value = copy.dataset.copyUrl;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.append(field);
          field.select();
          document.execCommand('copy');
          field.remove();
          copy.textContent = copy.dataset.copiedLabel;
          window.setTimeout(() => { copy.textContent = copy.dataset.copyLabel; }, 1600);
        }
      }
    });
    document.addEventListener('click', event => { if (sort.open && !sort.contains(event.target)) sort.open = false; });
  })();

  } catch(e) { console.error(e); }
})();
})();
